import { SettingsComponent } from './settings.component';
export var settingsRoutes = [
    {
        path: 'settings',
        component: SettingsComponent,
        data: {
            'expectedRoles': ['Admin']
        },
    },
];
var SettingsRoutingModule = (function () {
    function SettingsRoutingModule() {
    }
    return SettingsRoutingModule;
}());
export { SettingsRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/settings/settings-routing.module.ts.pre-build-optimizer.js